import { render, staticRenderFns } from "./MailSolutionCostsPanel.vue?vue&type=template&id=07f7be4e&scoped=true&"
import script from "./MailSolutionCostsPanel.vue?vue&type=script&lang=js&"
export * from "./MailSolutionCostsPanel.vue?vue&type=script&lang=js&"
import style0 from "./MailSolutionCostsPanel.vue?vue&type=style&index=0&id=07f7be4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f7be4e",
  null
  
)

export default component.exports